import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslation from './en/translation.json';
import faTranslation from './fa/translation.json';

const resources = {
  fa: {
    translation: faTranslation
  },
  en: {
    translation: enTranslation
  }
};

i18n
  .use(initReactI18next) 
  .init({
    resources,
    lng: "fa", 
    fallbackLng: 'fa',
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

  export default i18n;